import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminWbrPage } from '@apps/web/features/admin_wbr';
import { WBR_FUNCTIONS } from '@apps/web/features/admin_wbr/metrics';

export const Route = createFileRoute('/_app/admin/wbr')({
    validateSearch: z.object({
        view: z.enum(WBR_FUNCTIONS).optional().catch(undefined),
    }),
    head: () => ({ meta: [{ title: 'WBR | Phoebe Admin' }] }),
    component: AdminWbrRoute,
});

function AdminWbrRoute() {
    const { view = 'company' } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <AdminWbrPage
            view={view}
            onViewChange={(nextView) => {
                void navigate({
                    search: {
                        view: nextView === 'company' ? undefined : nextView,
                    },
                });
            }}
        />
    );
}
